import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

const EditPen = ({ className }) => (
  <svg className={cn('icon', 'icon-editpen', className)} width="15px" height="16px" viewBox="0 0 15 16">
    <g id="pen">
      <path
        id="Path-4"
        className={cn(!className && 'st0')}
        d="M10,1.6809639 L13.0848389,4.69249954 L14.4782104,3.25945511 C14.7407837,2.88559443 14.7407837,2.55714391 14.4782104,2.27410355 C14.2156372,1.99106318 13.5670573,1.32329788 12.5324707,0.270807647 C12.1741277,-0.0743938159 11.8374578,-0.0895712248 11.5224609,0.22527542 C11.5141424,0.233589974 11.0066554,0.718819467 10,1.6809639 Z"
      />
      <polygon
        id="Path-3"
        className={cn(!className && 'st0')}
        points="0 12.8037313 0 15.6425781 2.84205853 15.6425781 12.2797852 6.00732422 9.16967773 3"
      />
    </g>
  </svg>
);
EditPen.propTypes = {
  className: PropTypes.string,
};
EditPen.defaultProps = {
  className: '',
};
export default EditPen;
